<template lang="pug">
el-dialog(
  :visible.sync="modalAberto",
  width="880px",
  center,
  :close-on-click-modal="false",
  custom-class="modal-procedimentos",
  top="10vh",
  @close="close"
)
  span(slot="title")
    .titulo Médico
    el-switch(
      v-model="status",
      active-color="#13ce66",
      inactive-color="#e4e4e4"
    )
  .corpo-modal-procedimentos
    .tratamento
      label Tratamento
      el-select.tratamento-select(
        v-model="tratamento",
        placeholder="Selecione..."
      )
        el-option(
          v-for="item in optionTratamento",
          :key="item.value",
          :label="item.label",
          :value="item.value"
        )
    .nome-medico
      label Nome do Médico
        span *
      el-input(
        placeholder="Digite...",
        v-model="nome",
        :disabled="edicao ? true : false"
      )
      .validacao(v-if="validacaoNome") Nome Obrigatório!
    .data-nascimento
      label Data Nascimento
      el-input(
        v-model="nascimento",
        placeholder="00/00/0000",
        v-mask="'##/##/####'"
      )
    .cpf(:class="[cpfInvalido ? 'erro' : '']")
      label CPF
        span *
      el-input(
        v-model="cpf",
        placeholder="000.000.000-00",
        v-mask="'###.###.###-##'",
        @input="TestaCPF(cpf)",
        :disabled="edicao ? true : false"
      )
      .validacao(v-if="cpfInvalido") Digite um CPF válido
    .email
      label Email
      el-input(
        v-model="email",
        placeholder="Digite o email...",
        :maxlength="100"
      )
    ul.info-crm
      li(v-for="(crm, b) in conselho", :key="b")
        .crm
          .label
            label CRM
            .add(v-if="b === 0", @click="adicionaCrm")
              i.el-icon-plus
            .remove(v-else-if="b > 0", @click="removerCrm(b, crm)")
              i.el-icon-minus
            .remove(
              v-if="b === 0 && crm.bloqueiaCrm",
              @click="removerCrm(b, crm)"
            )
              i.el-icon-minus
          el-input(
            v-model="crm.crm",
            placeholder="0000",
            v-mask="'#######'",
            :disabled="crm.bloqueiaCrm"
          )
        .uf
          label UF
          el-select.uf-select(
            v-model="crm.valorUf",
            placeholder="Selecione...",
            :disabled="crm.bloqueiaCrm"
          )
            el-option(
              v-for="(uf, c) in crm.uf",
              :key="c",
              :label="uf.label",
              :value="uf.valor"
            )
    ul.info-especialidade
      li(v-for="(list, d) in especialidades", :key="d")
        .especialidade
          .label
            label Especialidade
            .add(v-if="d === 0", @click="adicionaEspecialidade")
              i.el-icon-plus
            .remove(v-else-if="d > 0", @click="removerEspecialidade(d, list)")
              i.el-icon-minus
            .remove(
              v-if="d === 0 && list.bloqueiaEspec",
              @click="removerEspecialidade(d, list)"
            )
              i.el-icon-minus
          el-select(
            v-model="list.idEspecialidade",
            placeholder="Selecione...",
            v-loading="loadEspecialidade",
            :disabled="list.bloqueiaEspec"
          )
            img.img-especialidade(
              slot="prefix",
              src="@/assets/especialidades.svg",
              :class="[list.idEspecialidade ? 'ativo' : 'inativo']"
            )
            el-option(
              v-for="(listEspec, e) in list.especialidades",
              :key="e",
              :label="listEspec.nome",
              :value="listEspec.id",
              :disabled="listEspec.status == 'I' ? true : false"
            )
        .rqe
          label RQE
          el-input(
            v-model="list.rqe",
            placeholder="0000",
            v-mask="'#######'",
            :disabled="list.bloqueiaEspec"
          )
    ul.info-unidade
      li(v-for="(list, f) in unidades", :key="f")
        .unidade
          .label
            label Unidade Médica
            .add(v-if="f === 0", @click="adicionaUnidade")
              i.el-icon-plus
            .remove(v-else-if="f > 0", @click="removerUnidade(f, list)")
              i.el-icon-minus
            .remove(
              v-if="f === 0 && list.bloqueiaUni",
              @click="removerUnidade(f, list)"
            )
              i.el-icon-minus
          el-select(
            v-model="list.idUnidade",
            placeholder="Selecione...",
            v-loading="loadUnidade",
            :disabled="list.bloqueiaUni"
          )
            img.img-especialidade(
              slot="prefix",
              src="@/assets/unidades.svg",
              :class="[list.idUnidade ? 'ativo' : 'inativo']"
            )
            el-option(
              v-for="(listUnit, g) in list.unidades",
              :key="g",
              :label="listUnit.nome",
              :value="listUnit.id",
              :disabled="listUnit.status == 'I' ? true : false"
            )
          ul.info-horario
            li
              label Horário de Atendimento Referente à Unidade
              el-input(
                placeholder="Digite o horário...",
                v-model="list.horarioAtendimento"
              )

  span.dialog-footer(slot="footer")
    el-button(
      @click="redefinirSenha",
      :loading="load",
      style="width: 250px",
      v-if="edicao"
    ) Reenviar senha
    el-button(type="primary", @click="salvar", :loading="loadBtn") Salvar
</template>

<script>
import Services from "../../utils/services";
import UF from "./uf";
import moment from "moment";
moment.locale("pt-BR");
import { mapGetters, mapMutations } from "vuex";

export default {
  props: ["openModal", "edicao"],

  data: () => ({
    cpfInvalido: false,
    validacaoNome: false,
    modalAberto: false,
    novoCadastro: true,
    loadBtn: false,
    load: false,
    status: true,
    tratamento: "",
    optionTratamento: [
      {
        value: "Dr",
        label: "Dr.",
      },
      {
        value: "Dra",
        label: "Dra.",
      },
    ],
    nome: "",
    nascimento: "",
    cpf: "",
    email: "",
    conselho: [
      {
        crm: "",
        uf: UF,
        valorUf: "",
        bloqueiaCrm: false,
        idCrm: null,
        idMedico: null,
      },
    ],
    especialidades: [
      {
        idEspecialidade: "",
        especialidades: [],
        rqe: null,
        bloqueiaEspec: false,
      },
    ],
    unidades: [
      {
        unidades: [],
        idUnidade: null,
        bloqueiaUni: false,
        horarioAtendimento: "",
      },
    ],
    loadEspecialidade: false,
    loadUnidade: false,
    unidadesDoMedico: [],
    especialidadesDoMedico: [],
    cascataCrm: true,
    cascataEspecialidades: true,
    cascataUnidades: true,
  }),

  watch: {
    openModal() {
      if (this.openModal) {
        this.modalAberto = true;
        this.getEspecialidades();
        this.getUnidades();

        if (this.edicao) {
          console.log("Edicao", this.edicao);
          let e = this.edicao;
          this.status = e.status === "A" ? true : false;
          this.tratamento = e.termo_tratamento;
          this.nome = e.nome;
          this.nascimento = moment(e.data_nascimento).format("L");
          this.cpf = e.cpf;
          this.email = e.email;
          this.conselho = [];
          if (e.crms.length) {
            e.crms.forEach((conselho) => {
              this.conselho.push({
                crm: conselho.crm,
                uf: UF,
                valorUf: conselho.uf_registro.toLowerCase(),
                bloqueiaCrm: true,
                idCrm: Number(conselho.id),
                idMedico: Number(conselho.id_medico),
              });
            });
          } else {
            this.conselho.push({
              crm: "",
              uf: UF,
              valorUf: "",
              bloqueiaCrm: false,
              idCrm: null,
              idMedico: null,
            });
          }
          if (e.especialidades.length) {
            this.especialidades = [];
            e.especialidades.forEach((espec) => {
              this.especialidades.push({
                idEspecialidade: Number(espec.id),
                especialidades: this.edicao.auxEspecialidade,
                rqe: espec.rqe,
                bloqueiaEspec: true,
              });
            });
          }
          if (e.unidades_medicas.length) {
            this.unidades = [];
            e.unidades_medicas.forEach((uni) => {
              this.unidades.push({
                unidades: this.edicao.auxUnidade,
                idUnidade: Number(uni.id),
                bloqueiaUni: true,
                horarioAtendimento: uni.horario_atendimento,
              });
            });
          }
          this.novoCadastro = false;
        }
      } else this.modalAberto = false;
    },
  },

  methods: {
    close() {
      this.$emit("close", true);
      this.limpaVariaveis();
    },

    /* Metodo que preenche o select de especialidades */
    async getEspecialidades() {
      this.loadEspecialidade = true;
      let auxEspecialidade = await Services.get("/especialidade");
      this.especialidades[0].especialidades = auxEspecialidade;
      this.auxEspecialidade = auxEspecialidade;
      if (this.especialidades) this.loadEspecialidade = false;
    },

    /* Metodo que preenche o select de unidades */
    async getUnidades() {
      this.loadUnidade = true;
      let auxUnidade = await Services.get("/unidade-medica");
      this.unidades[0].unidades = auxUnidade;
      this.unidadesDoMedicoEdicao = auxUnidade;
      if (this.unidades) this.loadUnidade = false;
      console.log(this.unidades);
    },

    /* Metodo que remove um CRM de um medico */
    async vinculaCrm(idMedico) {
      let aux = [];
      this.conselho.forEach((e) => {
        if (!e.bloqueiaCrm) {
          aux.push(e);
        }
      });
      if (aux.length) {
        for (let i = 0; i < aux.length; ) {
          let dados = {
            crm: aux[i].crm,
            uf: aux[i].valorUf,
            dataVencimento: "2019-09-12",
            status: "A",
          };
          let ok = await Services.post(`/medico/${idMedico}/crm`, dados);
          if (ok) i++;
        }
      } else {
        return false;
      }
    },

    /* Metodo que vincula/desvincula um RQE a um medico */
    async vinculaDesvicnulaRqe(idMedico, acao) {
      let aux = [];
      this.especialidades.forEach((e) => {
        if (!e.bloqueiaEspec) {
          aux.push(e);
        }
      });
      if (aux.length) {
        for (let i = 0; i < aux.length; ) {
          let dados = {
            rqe: aux[i].rqe,
          };
          let ok = await Services.put(
            `/medico/${idMedico}/especialidade/${aux[i].idEspecialidade}/${acao}`,
            dados
          );
          if (ok) i++;
        }
      } else {
        return false;
      }
    },

    /* Metodo que vincula/desvincula um medico a uma unidade */
    async vinculaDesvinculaUnidade(idMedico, acao) {
      let aux = [];
      this.unidades.forEach((e) => {
        aux.push(e);
      });
      if (aux.length) {
        for (let i = 0; i < aux.length; ) {
          let ok = await Services.put(
            `/medico/${idMedico}/unidade-medica/${aux[i].idUnidade}/${acao}`,
            { horarioAtendimento: aux[i].horarioAtendimento }
          );
          if (ok) i++;
        }
      } else {
        return false;
      }
    },

    /* Método que salva e edita o cadastro de procedimentos */
    async salvar() {
      if (this.nome.length > 3 && !this.cpfInvalido && this.cpf) {
        this.validacaoNome = false;
        this.loadBtn = true;
        let data = JSON.stringify({
          nome: this.nome,
          cpf: this.cpf,
          status: this.status ? "A" : "I",
          dataNascimento: this.nascimento.split("/").reverse().join("-"),
          genero: this.tratamento === "Dr" ? "M" : "F",
          email: this.email,
          termoTratamento: this.tratamento,
        });
        console.log("salvar", data);
        if (this.edicao) {
          if (this.conselho[0].crm) {
            this.vinculaCrm(this.edicao.id_medico); // Chamando Metodo que vincula o CRM do Medico
          }
          if (this.especialidades[0].idEspecialidade) {
            this.vinculaDesvicnulaRqe(this.edicao.id_medico, "vincular"); // Chamando Metodo que vincula especialidades e RQE do medico
          }
          if (this.unidades[0].idUnidade) {
            this.vinculaDesvinculaUnidade(this.edicao.id_medico, "vincular"); // Chamando Metodo que vincula o Medico a uma Unidade Medica
          }
          /* Condição que edita o cadastro dos procedimentos */
          let editar = await Services.put(
            `/medico/${this.edicao.id_medico}`,
            data
          );
          if (editar) {
            this.loadBtn = false;
            this.$message({
              message: "Edição realizada com sucesso!",
              type: "success",
              duration: 2000,
            });
            setTimeout(() => {
              this.close();
              this.limpaVariaveis();
              this.$emit("atualiza", true);
            }, 2000);
          } else {
            this.loadBtn = false;
            this.$message({
              message: "Houve um erro na edição, tente novamente!",
              type: "error",
              duration: 3000,
            });
          }
        } else {
          /* Condição que efetua o cadastro de um novo paciente */
          let salvar = await Services.post("/medico", data);
          console.log(salvar);
          if (salvar === "ja existe uma pessoa vinculada a esse cpf") {
            this.loadBtn = false;
            this.cpfInvalido = true;
            this.$message({
              message:
                "Já existe uma pessoa vinculada a esse CPF, insira outro e tente novamente!",
              type: "error",
              duration: 4000,
            });
            return false;
          }
          if (typeof salvar == "number") {
            if (this.conselho[0].crm) {
              this.vinculaCrm(salvar); // Chamando Metodo que vincula o CRM do Medico
            }
            if (this.especialidades[0].idEspecialidade) {
              this.vinculaDesvicnulaRqe(salvar, "vincular"); // Chamando Metodo que vincula especialidades e RQE do medico
            }
            if (this.unidades[0].idUnidade) {
              this.vinculaDesvinculaUnidade(salvar, "vincular"); // Chamando Metodo que vincula o Medico a uma Unidade Medica
            }

            this.loadBtn = false;
            this.$message({
              message: "Cadastro realizado com sucesso!",
              type: "success",
              duration: 2000,
            });
            setTimeout(() => {
              this.close();
              this.limpaVariaveis();
              this.$emit("atualiza", true);
            }, 2000);
          } else {
            this.loadBtn = false;
            this.$message({
              message: "Houve um erro no cadastro, tente novamente!",
              type: "error",
              duration: 3000,
            });
          }
        }
      } else {
        if (this.nome.length < 3 || this.cpfInvalido) {
          this.validacaoNome = true;
          this.cpfInvalido = true;
          this.$message({
            message: "Preencha os campos obrigatórios e tente novamente!",
            type: "error",
            duration: 3000,
          });
        }
        if (this.nome.length > 3) this.validacaoNome = false;
      }
    },

    async redefinirSenha() {
      this.load = true;
      let resp = await Services.get(
        `/usuario/${this.edicao.cpf}/recuperar-senha`
      ).catch((e) => {
        this.$message({
          message: e.response.data,
          type: "error",
          duration: 4000,
        });
        this.load = false;
      });

      if (resp) {
        this.load = false;
        this.$message({
          message: "Senha redefinida, verificar o email!",
          type: "success",
          duration: 4000,
        });
      }
    },

    /* Metodo que adiciona no array mais um CRM */
    adicionaCrm() {
      let crm = {
        crm: "",
        uf: UF,
        valorUf: "",
        bloqueiaCrm: false,
        idCrm: null,
        idMedico: null,
      };
      this.conselho.push(crm);
    },

    /* Metodo que adiciona no array mais uma linha de especialidade */
    adicionaEspecialidade() {
      let especialidade = {
        idEspecialidade: "",
        especialidades: this.especialidades[0].especialidades,
        rqe: null,
      };
      this.especialidades.push(especialidade);
    },

    /* Metodo que adiciona no array mais uma linha de unidade */
    adicionaUnidade() {
      let unidades = {
        unidades: this.unidades[0].unidades,
        idUnidade: null,
      };
      this.unidades.push(unidades);
    },

    /* Metodo que remove do array um CRM */
    removerCrm(indice, dados) {
      console.log("dados remove crm", dados);
      if (indice === 0) {
        this.cascataCrm = false;
        this.conselho.splice(indice, 1);
        this.conselho.push({
          crm: "",
          uf: UF,
          valorUf: "",
          bloqueiaCrm: false,
        });
        this.removerCrmPersistencia(dados.idMedico, dados.idCrm);
      } else {
        this.cascataCrm = true;
        this.conselho.splice(indice, 1);
        this.removerCrmPersistencia(dados.idMedico, dados.idCrm);
      }
    },
    /* Metodo que faz a remocao do crm do banco de dados */
    async removerCrmPersistencia(idMedico, idCrm) {
      let ok = await Services.delete(`/medico/${idMedico}/crm/${idCrm}`);
      console.log(ok);
    },

    /* Metodo que remove do array uma Especialidade */
    removerEspecialidade(indice, dados) {
      if (indice === 0) {
        this.cascataEspecialidades = false;
        this.removerEspecPersistencia(
          this.edicao.id_medico,
          dados.idEspecialidade,
          dados.rqe
        );
        this.especialidades.splice(indice, 1);
        this.especialidades.push({
          idEspecialidade: "",
          especialidades: this.edicao.auxEspecialidade,
          rqe: null,
          bloqueiaEspec: false,
        });
      } else {
        this.cascataEspecialidades = true;
        this.especialidades.splice(indice, 1);
        this.removerEspecPersistencia(
          this.edicao.id_medico,
          dados.idEspecialidade,
          dados.rqe
        );
      }
    },
    /* Metodo que faz a remocao da especialidade do banco de dados */
    async removerEspecPersistencia(idMedico, idEspec, rqe) {
      let dados = { rqe: rqe };
      let ok = Services.put(
        `/medico/${idMedico}/especialidade/${idEspec}/desvincular`,
        dados
      );
    },

    /* Metodo que remove do array uma Unidade */
    removerUnidade(indice, dados) {
      if (indice === 0) {
        this.cascataUnidades = false;
        this.removerUniPersistencia(this.edicao.id_medico, dados.idUnidade);
        this.unidades.splice(indice, 1);
        this.unidades.push({
          idEspecialidade: "",
          especialidades: this.edicao.auxUnidade,
          rqe: null,
          bloqueiaEspec: false,
        });
      } else {
        this.cascataUnidades = true;
        this.unidades.splice(indice, 1);
        this.removerUniPersistencia(this.edicao.id_medico, dados.idUnidade);
      }
    },
    /* Metodo que faz a remocao da unidade-medica do banco de dados */
    async removerUniPersistencia(idMedico, idUni) {
      let ok = Services.put(
        `/medico/${idMedico}/unidade-medica/${idUni}/desvincular`
      );
    },

    /* Metodo que limpa os campos */
    limpaVariaveis() {
      this.status = true;
      (this.cpfInvalido = false),
        (this.validacaoNome = false),
        (this.nome = "");
      this.nascimento = "";
      this.cpf = "";
      this.email = "";
      this.horarioAtendimento = "";
      (this.conselho = [
        {
          crm: "",
          uf: UF,
          valorUf: "",
          bloqueiaCrm: false,
          idCrm: null,
          idMedico: null,
        },
      ]),
        (this.especialidades = [
          {
            idEspecialidade: "",
            especialidades: [],
            rqe: null,
            bloqueiaEspec: false,
          },
        ]),
        (this.unidades = [
          {
            unidades: [],
            idUnidade: null,
            bloqueiaUni: false,
          },
        ]),
        (this.validacaoNome = false);
    },

    /* Metodo que verifica se o CPF digitado é um cpf valido */
    TestaCPF(strCPF) {
      let cpf = strCPF.replace(/[^\d]+/g, "");
      let Soma;
      let Resto;
      let i;
      Soma = 0;
      if (cpf == "00000000000") return (this.cpfInvalido = true);
      for (i = 1; i <= 9; i++)
        Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;
      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(cpf.substring(9, 10)))
        return (this.cpfInvalido = true);
      Soma = 0;
      for (i = 1; i <= 10; i++)
        Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;
      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(cpf.substring(10, 11)))
        return (this.cpfInvalido = true);
      return (this.cpfInvalido = false);
    },
  },
};
</script>

<style lang="scss">
.el-dialog.modal-procedimentos {
  border-radius: 20px;

  .el-dialog__header {
    padding-top: 50px;

    span {
      display: flex;
      align-items: center;
      justify-content: center;

      .titulo {
        font-size: 32px;
        color: #000;
        font-weight: 100;
      }

      .el-switch {
        margin-left: 20px;

        .el-switch__core {
          width: 45px !important;
          height: 25px;
          border-radius: 20px;

          &::after {
            width: 21px;
            height: 21px;
          }
        }

        &.is-checked {
          .el-switch__core {
            &::after {
              margin-left: -25px;
            }
          }
        }
      }
    }
    button.el-dialog__headerbtn {
      top: 50px;

      i {
        font-size: 33px;
      }
    }
  }

  .el-dialog__body {
    .corpo-modal-procedimentos {
      padding: 45px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      label {
        font-size: 17px;
        color: #0180ff;
        font-weight: 400;

        span {
          margin-left: 3px;
          color: red;
        }
      }
      .el-input {
        input {
          border-right: none;
          border-top: none;
          border-left: none;
          border-radius: 0;
          padding-left: 0;
          font-size: 22px;
          color: #000;
          font-weight: 300;
        }
      }
      .el-select {
        &.uf-select,
        &.tratamento-select {
          .el-input {
            input.el-input__inner {
              padding-left: 0;
            }
          }
        }
        .el-input {
          input.el-input__inner {
            padding-left: 50px;
          }
          .el-input__suffix {
            right: -5px;

            .el-input__suffix-inner {
              i {
                font-size: 22px;
                color: #0180ff;
                font-weight: bold;
              }
            }
          }
          .el-input__prefix {
            img.img-especialidade,
            img.img-unidade {
              width: 30px;
              margin-top: 5px;

              &.inativo {
                filter: grayscale(1);
              }
            }
          }
        }
      }

      .tratamento,
      .data-nascimento {
        width: 140px;
      }
      .nome-medico {
        width: 575px;
      }
      .cpf {
        width: 185px;
      }
      .nome-medico,
      .cpf {
        position: relative;

        .validacao {
          position: absolute;
          font-size: 12px;
          bottom: -17px;
          color: red;
        }
      }
      .email {
        width: 370px;
      }
      ul.info-crm,
      ul.info-especialidade,
      ul.info-unidade {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-top: 25px;

        li {
          width: 100%;
          list-style: none;
          display: flex;
          justify-content: space-between;

          .label {
            display: flex;
            align-items: center;

            .add,
            .remove {
              width: 22px;
              height: 22px;
              border-radius: 100px;
              background: #d9ecff;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;
              cursor: pointer;

              i {
                color: #0180ff;
                line-height: 0;
                font-weight: bold;
                font-size: 12px;
              }
            }
          }

          &:not(:first-child) {
            margin-top: 25px;
          }

          .crm,
          .especialidade {
            width: 540px;

            .el-select {
              width: 100%;
            }
          }
          .uf,
          .rqe {
            width: 135px;
          }

          .unidade {
            width: 100%;

            .el-select {
              width: 100%;
            }

            .info-horario {
              list-style: none;
              width: 100%;
              padding-left: 0;

              li {
                width: 100%;
                display: flex;
                flex-direction: column;
                margin-top: 10px;
              }
            }
          }
          .especialidade {
            margin-top: 0;
          }
        }
      }
      .data-nascimento,
      .cpf,
      .email {
        margin-top: 25px;
      }
    }
  }

  .el-dialog__footer {
    padding-bottom: 50px;
    padding-top: 0;

    .el-button {
      width: 180px;
      height: 60px;
      font-size: 22px;
      border-radius: 8px;
      font-weight: 300;
    }
  }
}
</style>